import React from "react";
import { Navigate } from "react-router-dom";

function RouteGuard({
  element,
  isAuth,
  requiresAuth = false,
  isAllowed = true,
  redirectToLogin = "/",
  redirectToHome = "/home",
}) {
  if (requiresAuth && !isAuth) {
    return <Navigate to={redirectToLogin} replace />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectToHome} replace />;
  }

  return element;
}

export default RouteGuard;
